jQuery(document).ready(function ($) {
    const LOADING = $("#loading");
    const MINI_CART_DRAWER = new bootstrap.Offcanvas($("#miniCart"));
    const MINI_CART = $("#miniCart");
    const OOS_MODAL = $("#oosModal").length ? new bootstrap.Modal($("#oosModal")) : null;
    const PRODUCT_SELECT_DRAWER = $("#changeVariant").length ? new bootstrap.Offcanvas($("#changeVariant")) : null;
    const PADDING_TOP = 20;
    const PADDING_TOP_HOME = 80;
    const HEADER_MENU = $("#header .header_menu");
    const HEADER_HEIGHT = $("#header").outerHeight();
    const T = window.disorder.language;
    const LANG = window.disorder.storeLocale;
    var REL = window.location.pathname;
    if (window.location.pathname.startsWith(LANG.root) && LANG.code != "en") {
        REL = REL.replace(LANG.root, "");
    }

    var featuredDrawersBs = [];
    $(".offcanvas[data-role='change-variant-drawer']").each(function () {
        featuredDrawersBs.push({
            drawer: new bootstrap.Offcanvas($(this)),
            section: $(this).attr("data-section")
        });
    });

    var device = "mobile";
    if ($(window).width() > 768) device = "desk";

    var oosVariantId;
    //multilang
    $("a[name='multilangToggle']").click(function () {
        let newRel = REL.replace("/en", "");
        newRel = newRel.startsWith("/") ? newRel : "/" + newRel;
        if ($(this).attr("data-value") == "/") {
            if (!newRel.length) {
                window.location = "/";
                return;
            }
            window.location = newRel;
        } else {
            window.location = $(this).attr("data-value") + newRel;
        }
    })

    //announce bar init
    var announceBar = $("#AnnounceBar").length ? new bootstrap.Carousel($("#AnnounceBar")) : false;
    if ($("#AnnounceBar").hasClass("rtl-carousel") && announceBar) {
        announceBar.pause();
        $("#AnnounceBar").find('> .carousel-inner > .carousel-item:not(:first-child)').each(function () {
            $(this).prependTo(this.parentNode);
        });
        announceBar.cycle = function (e) {
            if (!e) this.paused = false
            if (this.interval) clearInterval(this.interval);
            this._config.interval
                && !this.paused
                && (this.interval = setInterval($.proxy(this.prev, this), this._config.interval))
            return this;
        };
    }
    announceBar.cycle();

    //slide-shows init
    $(".slideshow").each(function () {
        var el = new bootstrap.Carousel($(this));
        if ($(this).hasClass("rtl-carousel")) {
            el.pause();

            $(this).find('> .carousel-inner > .carousel-item:not(:first-child)').each(function () {
                $(this).prependTo(this.parentNode);
            });

            el.cycle = function (e) {
                if (!e) this.paused = false
                if (this.interval) clearInterval(this.interval);
                this._config.interval
                    && !this.paused
                    && (this.interval = setInterval($.proxy(this.prev, this), this._config.interval))
                return this;
            };
        }
        el.cycle();
    });

    var upsellTag = "upsell-general";
    function updateUpsellTag() {
        let _ = window.disorder.current.upsellProduct.tags;
        if(_) {
            if (_.some(tag => tag.includes("upsell"))) {
                upsellTag = _.find(tag => tag.includes("upsell"));
            } else {
                upsellTag = "upsell-general";
            }
        }
    }
    updateUpsellTag();

    //swiper carousel init
    var swiper = new Swiper('.swiper', {
        slidesPerView: "auto",
        loop: false,
        simulateTouch: true,
        freeMode: true,
        navigation: {
            nextEl: '.cus-button-next',
            prevEl: '.cus-button-prev',
        }
    });


    let cardWidth = 25;
    if ($(window).width() > 1938) cardWidth = 35;
    var topForArrow = $(window).width() * cardWidth / 100 / 2 * 1.25 - 25;
    $(".arrow-fix").css("top", `${topForArrow}px`);

      var idus_swiper = new Swiper(".idus-slider-scroll-wrapper", {
        slidesPerView: 1.3,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 25
          }
        },
    navigation: {
      nextEl: ".idus_slider_arrow_next",
      prevEl: ".idus_slider_arrow_prev",
      },
    });

    //add to cart
    function listenToAtcButton() {
        $("button[name='atc']").off();
        $("button[name='atc']").click(function () {
            let el = $(this);
            let elId = el.attr("id");
            let sectionId = false;
            if (elId.includes("Sec-AddToCart-")) {
                sectionId = elId.split("-")[2];
            }
            let variantId = +el.attr("data-variant");
            if (!variantId) {
                if (device == "mobile") {
                    if (sectionId) {
                        featuredDrawersBs.find(x => x.section == sectionId).drawer.show();
                        return;
                    }
                    PRODUCT_SELECT_DRAWER.show();
                } else {
                    if (sectionId) {
                        $(`.options-title[data-atc=${sectionId}]`).addClass("error");
                        return;
                    }
                    $(".options-title").addClass("error");
                }
                return;
            }
            let oosState = el.attr("data-oos");
            if (oosState == "true") {
                OOS_MODAL.show();
                oosVariantId = variantId;
                return;
            }
            MINI_CART_DRAWER.show();
            startLoading(true);
            upsellTag = el.attr("data-upsell");
            addToCart(variantId);
            if (el.attr('id') == "upsellAddToCart" && $("#upsellVariantSelectOptions").length > 0) {
                if ($("#upsellVariantSelectOptions").html().length > 0) {
                    new bootstrap.Collapse($("#upsellVariantSelect")).hide();
                    $("#upsellAddToCart").text(T.add_to_cart);
                }
            }
        });
    }
    listenToAtcButton();

    function addToCart(id, qty = 0, callback = false) {
        let postData = {
            items: [
                {
                    id: id,
                    quantity: qty ? qty : 1
                }
            ]
        }

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: postData,
            dataType: "json",
            success: buildCart,
            error: atcError
        }).then(() => { if (callback) { callback(); } });
    }

    function buildCart() {
        $.getJSON("/cart.js", function (cart) {
            updateMiniCartSubtotal(cart.total_price);
            $("#miniCartItems").empty();
            cart.items.forEach(item => {
                // console.log(item);
                let isMerch = false;
                if (item.product_type == "Merch") isMerch = true;
                let noVariants = false;
                if (item.variant_title == null) noVariants = true;
                if (noVariants) {
                    $("#miniCartItems").append(`
                    <div class="item" data-variant="${item.id}" data-quantity="${item.quantity}" data-handle="${item.handle}">
                <div class="img-wrp ${isMerch ? "merch" : ""}">
                  <img src="${item.image}"><br>
                </div>
                <div class="txt-wrp">
                  <div class="product-header">
                    <div class="title">${item.product_title}</div>
                    <div class="remove-wrp"><span class="remove" data-variant="${item.id}">X</span></div>
                  </div>
                  <div class="bottom-row">
                    <div class="product-controls">
                    <span class="minus" data-variant="${item.id}">-</span>
                    <span class="qty" data-variant="${item.id}">${item.quantity}</span>
                    <span class="plus" data-variant="${item.id}">+</span>
                    </div>
                    <div class="price">${displayMoney(item.original_price)}</div>
                  </div>
                </div>
              </div>
                    `);
                } else {
                    $("#miniCartItems").append(`
                        <div class="item" data-variant="${item.id}" data-quantity="${item.quantity}" data-handle="${item.handle}">
                    <div class="img-wrp ${isMerch ? "merch" : ""}">
                      <img src="${item.image}"><br>
                    </div>
                    <div class="txt-wrp">
                      <div class="product-header">
                        <div class="title">${item.product_title}</div>
                        <div class="remove-wrp"><span class="remove" data-variant="${item.id}">X</span></div>
                      </div>
                      <div class="variant">
                        ${isMerch ? "" : "<div class='option-color-item " + item.variant_options[0].toLowerCase().replace(" ","") + "'></div>"}
                        <div class="option-name">${item.variant_title}</div>
                      </div>
                      <div class="bottom-row">
                        <div class="product-controls">
                        <span class="minus" data-variant="${item.id}">-</span>
                        <span class="qty" data-variant="${item.id}">${item.quantity}</span>
                        <span class="plus" data-variant="${item.id}">+</span>
                        </div>
                        <div class="price">${displayMoney(item.original_price)}</div>
                      </div>
                    </div>
                  </div>
                        `);
                }
            });
            updateItemsCount(cart.item_count);
            findNewUpsellProduct();
        }).then(() => {
            doneLoading(true);
        });
    }

    function atcError(data) {
        console.log(data);
        alert("Out of stock");
        doneLoading(true);
    }

    //mini cart controls
    $("#miniCart").on("click", ".product-controls .plus", function () {
        let el = $(this);
        let qty = +$(`.qty[data-variant="${el.data("variant")}"]`).text();
        qty++;
        changeCart(el.data("variant"), qty);
    });

    $("#miniCart").on("click", ".product-controls .minus", function () {
        let el = $(this);
        let qty = +$(`.qty[data-variant="${el.data("variant")}"]`).text();
        qty--;
        changeCart(el.data("variant"), qty);
    });

    $("#miniCart").on("click", ".product-header .remove", function () {
        let el = $(this);
        changeCart(el.data("variant"), 0);
    });

    function changeCart(variantId, qty) {
        let postData = {
            id: variantId,
            quantity: qty
        }

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: postData,
            dataType: "json",
            success: function (data) { cartChangeOK(data, variantId) },
            error: function (data) { atcError(data) }
        });
    }

    function cartChangeOK(cart, variantId = false) {
        updateMiniCartSubtotal(cart.total_price);
        if (!variantId) {
            buildCart();
            return;
        }
        if (cart.items.find(x => x.id == variantId)) {
            let newQty = cart.items.find(x => x.id == variantId).quantity;
            $(`.qty[data-variant="${variantId}"]`).text(newQty);
        } else {
            $(`.item[data-variant="${variantId}"]`).remove();
        }
        updateItemsCount(cart.item_count);
        doneLoading(true);
    }

    function updateMiniCartSubtotal(subtotal) {
        $("#miniCartSubtotal").text(displayMoney(subtotal));
    }

    function addToCartItems(id, qty = 0) {
        let items = [];
        id.forEach((item, i) => {
            items.push({
                id: item,
                quantity: qty ? qty[i] : 1
            })
        })
        let postData = {
            items: items
        }

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: postData,
            dataType: "json",
            success: buildCart,
            error: atcError
        });
    }

    //upsell variant selector
    let activeOptions;
    function listenToUpsellOptions() {
        listenToAtcButton();
        if($("#upsellVariantSelectOptions").length == 0) return;
        if($("#upsellVariantSelectOptions").html().length == 0) return;
        activeOptions = [];
        window.disorder.current.upsellProduct.options.forEach(optionItem => {
            activeOptions.push("");
            if (optionItem.name) {
                $(`#upsellVariantSelectOptions .options[data-group='${optionItem.name}'] .option`).click(function () {
                    let el = $(this);
                    let option = el.data("option");
                    let position = +el.data("position") - 1;

                    $(`#upsellVariantSelectOptions .options[data-group='${optionItem.name}'] .option.active`).removeClass("active");
                    el.addClass("active");

                    activeOptions[position] = option;
                    setActiveVariant();
                });
            } else {
                $(`#upsellVariantSelectOptions .options[data-group='${optionItem}'] .option`).click(function () {
                    let el = $(this);
                    let option = el.data("option");
                    let position = +el.data("position") - 1;

                    $(`#upsellVariantSelectOptions .options[data-group='${optionItem}'] .option.active`).removeClass("active");
                    el.addClass("active");

                    activeOptions[position] = option;
                    setActiveVariant();
                });
            }
        });
    }
    if (window.disorder.current.upsellProduct.options) listenToUpsellOptions();

    //update upsell module
    function setActiveVariant() {
        let atcUpsell = $("#upsellAddToCart");
        let variant;
        let potential = [...window.disorder.current.upsellProduct.variants];
        activeOptions.forEach((optionItem, i) => {
            potential = potential.filter(x => x.options[i] == optionItem);
        })
        if (!potential[0]) return;
        if (potential.length == 1) variant = potential[0];
        atcUpsell.attr("data-variant", variant.id);
        atcUpsell.attr("data-upsell", upsellTag);
        atcUpsell.text(T.add_to_cart + " - " + displayMoney(variant.price));
    }

    function findNewUpsellProduct() {
        console.log(upsellTag);
        $.getJSON("/collections/" + upsellTag + "/products.json", function (products) {
            let productsUpsellCheck = products.products;
            console.log(productsUpsellCheck)
            $("#miniCartItems .item").toArray().forEach(item => {
                productsUpsellCheck = productsUpsellCheck.filter(x => x.handle != $(item).data("handle"));
            });
            if (productsUpsellCheck.length == 0) {
                $("#miniCartUpsell").addClass("d-none");
                return;
            } else if ($("#miniCartUpsell").hasClass("d-none")) {
                $("#miniCartUpsell").removeClass("d-none");
            }
            updateUpsellProductInDom(findCheapestProduct(productsUpsellCheck));
        });
    }

    function updateUpsellProductInDom(newUpsellProduct) {
        $.getJSON("/products/" + newUpsellProduct.handle + ".js", function (product) {
            window.disorder.current.upsellProduct = product;
            $("#miniCartUpsell .item .item-info").html(`
            <div class="img-wrp">
            <img src="${product.images[0]}"><br>
            </div>
            <div class="txt-wrp">
            <div class="title">${product.title}</div>
            <div class="price">${displayMoney(product.price)}</div>
            </div>
            `);
            $("#upsellVariantSelectOptions").empty();
            if (product.variants.length > 1) {
                $("#upsellVariantSelect").show();
                $("#upsellToggle").show();
                product.options.forEach(option => {
                    let htmlOptions = "";
                    option.values.forEach(value => {
                        if (option.name != "Size") {
                            htmlOptions += `
                            <div class="option" data-position="${option.position}" data-option="${value}">
                            <div class="option-color-item ${value.toLowerCase().replace(" ", "")}"></div>
                            <div>${T[value.toLowerCase().replace(" ","_")] || value}</div>
                         </div>
                            `;
                        } else {
                            htmlOptions += `
                            <div class="option" data-position="${option.position}" data-option="${value}">
                            <div>${T[value.toLowerCase().replace(" ","_")] || value}</div>
                         </div>
                            `;
                        }
                    });
                    $("#upsellVariantSelectOptions").append(`
                    <div class="options" data-group="${option.name}">${htmlOptions}</div>
                    `);
                });
            } else {
                $("#upsellVariantSelect").hide();
                $("#upsellToggle").hide();
                if ($("#upsellAddToCart.full").length == 0) {
                    $("#miniCartUpsell .item").append(`
                    <button class="btn dark full" name="atc" data-variant="${product.variants[0].id}" id="upsellAddToCart">${T.add_to_cart}</button>
                    `);
                } else {
                    $("#upsellAddToCart").attr("data-variant", product.variants[0].id);
                }
            }
        }).then(() => {
            listenToUpsellOptions();
        });
    }

    function findCheapestProduct(products) {
        let newUpsellProduct = products[0];
        let cheapest = Number(products[0].variants[0].price);
        products.forEach(product => {
            product.variants.forEach(variant => {
                if (+variant.price < cheapest) {
                    cheapest = +variant.price;
                    newUpsellProduct = product;
                }
            });
        });
        return newUpsellProduct;
    }

    //accordion collapse toggle fix
    $(".item .collapse").on("show.bs.collapse", function (event) {
        event.stopPropagation();
        let id = "#" + $(this).attr("id");
        let parent = $(`.item[data-bs-target='${id}']`);
        parent.find(`.toggle[data-ident='${id}'`).children("img[name='plus']").addClass("d-none");
        parent.find(`.toggle[data-ident='${id}'`).children("img[name='minus']").removeClass("d-none");
        if ($(this).hasClass("collapse-inner")) {
            parent.find(".detailed-items").addClass("d-none");
            parent.find(".counter-items").removeClass("d-none");
        }
    });
    $(".item .collapse").on("hide.bs.collapse", function (event) {
        event.stopPropagation();
        let id = "#" + $(this).attr("id");
        let parent = $(`.item[data-bs-target='${id}']`);
        parent.find(`.toggle[data-ident='${id}'`).children("img[name='plus']").removeClass("d-none");
        parent.find(`.toggle[data-ident='${id}'`).children("img[name='minus']").addClass("d-none");
        if ($(this).hasClass("collapse-inner")) {
            parent.find(".detailed-items").removeClass("d-none");
            parent.find(".counter-items").addClass("d-none");
        }
    });

    //upsell collapse plus minus toggle
    $("#upsellVariantSelect").on("show.bs.collapse", function () {
        $(".select-option .toggle").children().toggleClass("d-none");
        checkMiniCartItemActiveScroll(true);
    });
    $("#upsellVariantSelect").on("hide.bs.collapse", function () {
        $(".select-option .toggle").children().toggleClass("d-none");
        checkMiniCartItemActiveScroll(false);
    });

    function checkMiniCartItemActiveScroll(flag) {
        if (flag && $("#miniCartItems .item").children().length == 2) {
            $("#miniCartItems").addClass("active-scroll");
            return;
        }
        if (!flag && $("#miniCartItems .item").children().length == 2 && $("#miniCartItems").hasClass("active-scroll")) {
            $("#miniCartItems").removeClass("active-scroll");
            return;
        }
    }

    //featured variant selector
    let activeFeatOptions = [];
    let fp = window.disorder.current.featProducts;
    if (fp) {
        fp.forEach((featProduct, i) => {
            activeFeatOptions.push([]);
            featProduct.product.options.forEach(optionItem => {
                activeFeatOptions[i].push("");
                $(`.${featProduct.section} .options[data-group='${optionItem}'] .option`).click(function () {
                    let el = $(this);
                    let option = el.data("option");
                    let position = +el.data("position") - 1;

                    $(`.${featProduct.section} .options[data-group='${optionItem}'] .option.active`).removeClass("active");
                    el.addClass("active");

                    activeFeatOptions[i][position] = option;
                    setActiveFeatVariant(featProduct.section);
                });
                $(`.change-variant[data-section='${featProduct.section}'] .options[data-group='${optionItem}'] .option`).click(function () {
                    let el = $(this);
                    let option = el.data("option");
                    let position = +el.data("position") - 1;

                    $(`.change-variant[data-section='${featProduct.section}'] .options[data-group='${optionItem}'] .option.active`).removeClass("active");
                    el.addClass("active");

                    activeFeatOptions[i][position] = option;
                    addToCartFromDrawer(true, featProduct.section);
                });
            });
        });
    }

    function setActiveFeatVariant(section) {
        let variant;
        let _ = window.disorder.current.featProducts;
        let potential = [..._.find(x => x.section == section).product.variants];
        activeFeatOptions[_.findIndex(x => x.section == section)].forEach((optionItem, i) => {
            potential = potential.filter(x => x.options[i] == optionItem);
        });
        if (!potential[0]) return;
        if (potential.length == 1) variant = potential[0];
        $(`.options-title[data-atc=${section}]`).removeClass("error");
        let atc = $(`#Sec-AddToCart-${section}`);
        atc.attr("data-variant", variant.id);
        atc.text(T.add_to_cart + " - " + displayMoney(variant.price));
    }

    //featured drawer
    $(".offcanvas[data-role='change-variant-drawer'] .header .close").click(function () {
        let sectionId = $(this).attr("data-section");
        featuredDrawersBs.find(x => x.section == sectionId).drawer.hide();
    });

    //product select drawer
    $("#changeVariant .header .close").click(function () {
        PRODUCT_SELECT_DRAWER.hide();
    });

    let activeOptionsDrawer = [];
    let cp = window.disorder.current.product;
    if (cp) {
        cp.options.forEach(optionItem => {
            activeOptionsDrawer.push("");
            $(`#changeVariant .options[data-group='${optionItem}'] .option`).click(function () {
                let el = $(this);
                let option = el.data("option");
                let position = +el.data("position") - 1;

                $(`#changeVariant .options[data-group='${optionItem}'] .option.active`).removeClass("active");
                el.addClass("active");

                activeOptionsDrawer[position] = option;
                addToCartFromDrawer();
            });
        });
    }


    function addToCartFromDrawer(flag = false, section = false) {
        let variant;
        let fp = window.disorder.current.featProducts;
        let cp = window.disorder.current.product;
        let potential = flag ? [...fp.find(x => x.section == section).product.variants] : [...cp.variants];
        if (flag) {
            activeFeatOptions[fp.findIndex(x => x.section == section)].forEach((optionItem, i) => {
                potential = potential.filter(x => x.options[i] == optionItem);
            });
        } else {
            activeOptionsDrawer.forEach((optionItem, i) => {
                potential = potential.filter(x => x.options[i] == optionItem);
            });
        }
        if (!potential[0]) return;
        if (potential.length == 1) variant = potential[0];
        let atc = flag ? $(`#changeVariantAddToCart-${section}`) : $("#changeVariantAddToCart-");
        let drawer = flag ? featuredDrawersBs.find(x => x.section == section).drawer : PRODUCT_SELECT_DRAWER;
        let callback = function () {
            atc.html(`
        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.85539 13.4959L2.65242 7.29294C2.2619 6.90241 1.62873 6.90241 1.23821 7.29294C0.847681 7.68346 0.847681 8.31663 1.23821 8.70715L8.23821 15.7071C8.66213 16.1311 9.36123 16.0893 9.73163 15.6179L20.7316 1.61786C21.0728 1.18359 20.9974 0.554938 20.5631 0.213724C20.1289 -0.127489 19.5002 -0.0520506 19.159 0.382221L8.85539 13.4959Z" fill="white"/>
        </svg>${T.added}
        `);
            atc.addClass("added");
            setTimeout(function () {
                drawer.hide();
                MINI_CART_DRAWER.show();
                setTimeout(function () {
                    atc.removeClass("added");
                    atc.text(T.select_option);
                }, 350)
            }, 1000);
        }
        startLoading(true);
        addToCart(variant.id, 1, callback);
    }

    //padding top fix
    let headerHeight = HEADER_HEIGHT + PADDING_TOP;
    $(`<style type='text/css'> .top-padding-product { padding-top: ${headerHeight}px !important;padding-bottom: ${headerHeight}px !important;} </style>`).appendTo("head");
    headerHeight += PADDING_TOP_HOME - PADDING_TOP;
    $(`<style type='text/css'> .top-padding-home { padding-top: ${headerHeight}px !important;} </style>`).appendTo("head");

    //account dropdown
    var accountDropdown = new bootstrap.Dropdown($("#accountMenu"));
    if (device == "desk") {
        var userInDropdown = false;
        $(".account-dropdown").hover(
            function () {
                accountDropdown.show();
            }, function () {
                $("#accountMenuEl").hover(
                    function () {
                        userInDropdown = true;
                    }, function () {
                        accountDropdown.hide();
                        userInDropdown = false;
                    }
                );
                setTimeout(function () {
                    if (userInDropdown) return;
                    accountDropdown.hide();
                    userInDropdown = false;
                }, 100);
            }
        );
    }

    //press slides
    let pressSlides = $(".press-wrapper");
    if (+pressSlides.attr("data-duration")) {
        //auto play
    }

    pressSlides.on("click", "img", function () {
        let el = $(this);
        if (el.hasClass("show")) return;
        let slide = el.attr("data-slide");
        pressSlides.children("h3.show").removeClass("show");
        pressSlides.children(`h3[data-slide='${slide}']`).addClass("show");
        pressSlides.children(".press-logos").children(".show").removeClass("show");
        el.addClass("show");
    });

    //"load all" buttons
    var loadAllStoriesButton = $("#loadAllStories");
    loadAllStoriesButton.click(function () {
        $(".blog-feed-wrapper").children().removeClass("d-none");
        $(".feed-load-wrapper").addClass("d-none");
    });
    var loadAllMerchButton = $("#loadAllMerch");
    loadAllMerchButton.click(function () {
        $(".collection-feed-wrapper.merch").children().removeClass("d-none");
        $(".feed-load-wrapper").addClass("d-none");
    });

    //oos modal submit
    let oosSubmitButton = $("#oosSubmit")
    oosSubmitButton.click(oosSubmit);
    function oosSubmit() {
        if (!$("span.error").hasClass("d-none")) $("span.error").addClass("d-none");
        let optin = $("input[name='optin']").prop("checked");
        let email = $("input[name='email']").val();
        if (!email) {
            $("span.error").text(T.error.no_email);
            $("span.error").removeClass("d-none");
            return;
        }
        BIS.create(email, oosVariantId, oosSubmitButton.attr("data-pid"), { accepts_marketing: optin }).then(res => {
            if (res.status == "OK") {
                $("#oosModal .modal-content").addClass("success");
                $("#oosModal h3").text(T.good_sub);
                setTimeout(function () {
                    OOS_MODAL.hide();
                }, 2000);
            } else {
                $("span.error").text(T.error.bad_email);
                $("span.error").removeClass("d-none");
            }
        });
    }

    //open minicart if necessary
    if (window.location.search.includes("minicart=true")) MINI_CART_DRAWER.show();

    //forms
    $("#recoverPassword").click(function(){
        showRecover();
    });

    $("#recoverCancel").click(function(){
        hideRecover();
    });

    if (window.location.hash == "#recover") showRecover();

    function showRecover() {
        $("#loginForm").addClass("d-none");
        $("#recoverForm").removeClass("d-none");
    }

    function hideRecover() {
        $("#loginForm").removeClass("d-none");
        $("#recoverForm").addClass("d-none");
    }

    //replace words on hero title
    const WORD_EL = $("#replaceMe");
    let heroWords;
    let wordIndex;
    let wordsDelay;
    if (WORD_EL.length > 0) {
        heroWords = [WORD_EL.text().trim()];
        wordIndex = 0;
        heroWords = heroWords.concat(WORD_EL.attr("data-words").split(","));
        wordsDelay = +WORD_EL.data("time") * 1000;
        setInterval(function () {
            wordIndex++;
            if (wordIndex == heroWords.length ) wordIndex = 0;
            replaceHeroWord();
        }, wordsDelay);
        replaceHeroWord();
    }
    
    function replaceHeroWord() {
        timeoutResolver(wordsDelay-500).then(() => { 
            WORD_EL.removeClass("magictime puffIn");
            WORD_EL.addClass("magictime puffOut");
            timeoutResolver(500).then(() => { 
                WORD_EL.text(`${heroWords[wordIndex]} `);
                WORD_EL.removeClass("magictime puffOut");
                WORD_EL.addClass("magictime puffIn");
             })
        });
    }

    function timeoutResolver(ms){
        return new Promise((resolve, reject) => {
            setTimeout(function () {
                resolve(true);
            }, ms)
        }); 
    }

    //sticky header
    let stickyAnnounceBar = $("#AnnounceBar").hasClass("p-fixed") ? $("#AnnounceBar").height() : false;
    stickyAnnounceBar = $("#AnnounceBar").hasClass("d-none") ? false : stickyAnnounceBar;
    let scrollSpy = [];
    let scrollDirection = true;
    let cleanUp = true;
    let lastCall = 0;
    let bottomTrigger = 60;
    if (device == "desk") {
        bottomTrigger = 60;
        if (stickyAnnounceBar) {
            $(`<style type='text/css'> .header_menu { top: ${stickyAnnounceBar};} </style>`).appendTo("head");
        }
    } else if (stickyAnnounceBar) {
        $(`<style type='text/css'> .header_menu { position: fixed; top: ${stickyAnnounceBar};} </style>`).appendTo("head");
    }
    $(window).scroll(function () {
        scrollSpy.push($(window).scrollTop());
        if (scrollSpy.length > 3) {
            if (scrollSpy[0] < scrollSpy[2]) scrollDirection = true;
            if (scrollSpy[0] > scrollSpy[2]) scrollDirection = false;
            scrollSpy = [];

            if ($(window).scrollTop() > 35 && scrollDirection && lastCall == 0 && $(window).scrollTop() <= bottomTrigger) {
                if (stickyAnnounceBar) {
                    HEADER_MENU.removeClass("sticky-announce");
                }
                HEADER_MENU.addClass("fixed-me");
                HEADER_MENU.addClass("fixed-me-in");
                if (stickyAnnounceBar) {
                    HEADER_MENU.css("top", stickyAnnounceBar);
                }
                lastCall = 1;
                cleanUp = true;
            }

            if ($(window).scrollTop() > bottomTrigger && scrollDirection && lastCall == 1) {
                HEADER_MENU.removeClass("fixed-me-in");
                HEADER_MENU.addClass("fixed-me-out");
                lastCall = 2;
            }

            if ($(window).scrollTop() < 36 && !scrollDirection && !cleanUp) {
                HEADER_MENU.removeClass("fixed-me");
                HEADER_MENU.removeClass("fixed-me-in");
                if (stickyAnnounceBar) {
                    HEADER_MENU.addClass("sticky-announce");
                }
                lastCall = 0;
            }

            if (cleanUp && !scrollDirection) {
                if (stickyAnnounceBar) {
                    HEADER_MENU.removeClass("sticky-announce");
                }
                if (!HEADER_MENU.hasClass("fixed-me")) {
                    HEADER_MENU.addClass("fixed-me");
                }
                HEADER_MENU.removeClass("fixed-me-out");
                HEADER_MENU.addClass("fixed-me-in");
                if (stickyAnnounceBar) {
                    HEADER_MENU.css("top", stickyAnnounceBar);
                }
                lastCall = -1;
                cleanUp = false;
            }
            if ($(window).scrollTop() > bottomTrigger && !cleanUp && scrollDirection) {
                HEADER_MENU.removeClass("fixed-me-in");
                HEADER_MENU.addClass("fixed-me-out");
                lastCall = 2;
                cleanUp = true;
            }
        }
        if ($(window).scrollTop() < 36) {
            HEADER_MENU.removeClass("fixed-me");
            HEADER_MENU.removeClass("fixed-me-in");
            if (stickyAnnounceBar) {
                HEADER_MENU.addClass("sticky-announce");
            }
            lastCall = 0;
        }
    });

    //************************WISHLIST*************/
    //fetch product in wishlist by user + init
    function waitForSwatWidget() {
        if (window._swat) {
            initWishlist()
        } else {
            setTimeout(waitForSwatWidget, 500);
        }
    }
    waitForSwatWidget();

    function initWishlist() {
        window._swat.fetch(function (r) {
            r.forEach(x => {
                $(`.atw[data-pid='${x.empi}']`).addClass("clicked");
            });
        });
        initWishlistPage();
    }

    //add to wishlist
    $(".atw").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("remove")) {
            removeFromWishlist($(this).attr("data-variant"), $(this).attr("data-pid"), $(this).attr("data-iu"), $(this).attr("data-price"), $(this).attr("data-handle"));
            $(`.feed .card[data-pid='${$(this).attr("data-pid")}']`).addClass("magictime puffOut");
            return;
        }
        if ($(this).hasClass("clicked")) {
            removeFromWishlist($(this).attr("data-variant"), $(this).attr("data-pid"), $(this).attr("data-iu"), $(this).attr("data-price"), $(this).attr("data-handle"));
        } else {
            addToWishlist($(this).attr("data-variant"), $(this).attr("data-pid"), $(this).attr("data-iu"), $(this).attr("data-price"), $(this).attr("data-handle"));
            $(this).children("svg").addClass("magictime puffIn");
        }

        $(this).toggleClass("clicked");
    });
    function wishlistRemoveListener() {
        $(".atw.remove").click(function (e) {
            e.preventDefault();
            removeFromWishlist($(this).attr("data-variant"), $(this).attr("data-pid"), $(this).attr("data-iu"), $(this).attr("data-price"), $(this).attr("data-handle"));
            $(`.feed .card[data-pid='${$(this).attr("data-pid")}']`).addClass("magictime swashOut").remove();
        });
    }

    function addToWishlist(variantId, productId, img_url, price, handle) {
        _swat.addToWishList(
            {
                "epi": variantId,
                "du": window.location.origin + LANG.root + "/products/" + handle,
                "empi": productId,
                "iu": img_url,
                "pr": price
            },
            function (r) {
                // console.log('Added to wishlist');
            }
        );
    }

    function removeFromWishlist(variantId, productId, img_url, price, handle) {
        _swat.removeFromWishList(
            {
                "epi": variantId,
                "du": window.location.origin + LANG.root + "/products/" + handle,
                "empi": productId,
                "iu": img_url,
                "pr": price
            },
            function (r) {
                // console.log('Removed to wishlist');
            }
        );
    }

    //fetch product in wishlist by user
    function initWishlistPage() {
        if ($(".main-content").data("template") == "page.wishlist") {
            _swat.fetch(function (data) {
                data.forEach(item => {
                    let productEndpoint = item.du.substring(item.du.indexOf("/products")) + ".js";
                    $.getJSON(productEndpoint, function (product) {
                        let merchClass = "";
                        let imageIndex = 1;
                        if (product.type == "Merch") { 
                            merchClass = "img-wrp--merch";
                            imageIndex = 0;
                        }
                        $(".wishlist-wrapper .feed").append(`
    <div class="card product-card-item" data-pid="${product.id}">
    <a class="h-link" href="${LANG.root + product.url}">
    <div class="wrp">
        <div class="aspec-1-1">
            <div class="img-wrp ${merchClass}">
                <img src="${product.images[imageIndex]}">
              </div>
        </div>
        <div class="on-img-wrp">
            <div class="atw remove" data-handle="${product.handle}" data-pid="${product.id}" data-iu="${product.featured_image}" data-variant="${product.variants[0].id}" data-price="${product.price / 100}">
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.96894 6.00001L12.2619 1.70701C12.6529 1.31601 12.6529 0.684006 12.2619 0.293006C11.8709 -0.0979941 11.2389 -0.0979941 10.8479 0.293006L6.55494 4.58601L2.26194 0.293006C1.87094 -0.0979941 1.23894 -0.0979941 0.847937 0.293006C0.456937 0.684006 0.456937 1.31601 0.847937 1.70701L5.14094 6.00001L0.847937 10.293C0.456937 10.684 0.456937 11.316 0.847937 11.707C1.04294 11.902 1.29894 12 1.55494 12C1.81094 12 2.06694 11.902 2.26194 11.707L6.55494 7.41401L10.8479 11.707C11.0429 11.902 11.2989 12 11.5549 12C11.8109 12 12.0669 11.902 12.2619 11.707C12.6529 11.316 12.6529 10.684 12.2619 10.293L7.96894 6.00001Z" fill="#1A1A1A"/>
                </svg>                   
            </div>
            <div class="body">
                <div class="title">${product.title}</div>
                <div class="price">${displayMoney(product.price)}</div>
                <div class="variants">${T.available_in}${product.variants.length} ${T.variants}</div>
            </div>
        </div>
    </div>
    </a>
</div>`);
                    });
                });
                waitForWishlistPage(data.length);
            });
        }

    }

    function waitForWishlistPage(l) {
        setTimeout(function () {
            if ($(".feed").children().length == l) {
                doneLoading();
                wishlistRemoveListener();
            } else {
                waitForWishlistPage(l);
            }
        }, 500);
    }

    //register form
    $("#registerSubmit").click(function () {
        if ($("#terms").is(":checked")) {
            $(this).submit();
        } else {
            alert(T.terms_alert);
            return false;
        }
    })

    //general
    function updateItemsCount(counter) {
        if ($("#miniCartItems .item").children().length > 2) {
            $("#miniCartItems").addClass("active-scroll");
        } else {
            $("#miniCartItems").removeClass("active-scroll");
        }
        if (counter == 0) {
            $("#itemsCount").addClass("d-none");
            $(".header_menu .icons").addClass("no-items");
            MINI_CART.addClass("empty-cart");
            MINI_CART_DRAWER.hide();
            return;
        }
        $("#itemsCount").removeClass("d-none");
        $(".header_menu .icons").removeClass("no-items");
        MINI_CART.removeClass("empty-cart");
        $("#itemsCount").text(counter);
        $("#miniCartHeaderCount").text("(" + counter + ")");
    }

    function displayMoney(totalToMoney) {
        if (LANG.code == "he") {
            return "₪" + totalToMoney / 100;
        }
        return "$" + ((totalToMoney / 100) * Shopify.currency.rate).toFixed(2);
        // return "$" + ((totalToMoney / 100) * window.Currency.rates.ILS).toFixed(2);
    }

    function startLoading(flag = false) {
        if (flag) {
            MINI_CART.addClass("loading");
            return;
        }
        LOADING.removeClass("done-loading");
        LOADING.addClass("d-flex");
    }

    function doneLoading(flag = false) {
        if (flag) {
            MINI_CART.removeClass("loading");
            return;
        }
        LOADING.addClass("done-loading");
        setTimeout(function () { LOADING.removeClass("d-flex"); }, 510);
    }
});

$(window).on("load", function () {
    const LOADING = $("#loading");
    function startLoading() {
        LOADING.removeClass("done-loading");
        LOADING.addClass("d-flex");
    }

    function doneLoading() {
        LOADING.addClass("done-loading");
        setTimeout(function () { LOADING.removeClass("d-flex"); }, 510);
    }
    if ($(".main-content").data("template") != "page.wishlist") doneLoading();

    //validate product object
    if ($(".main-content").data("template") == "product") {
        let _ = window.disorder.current.product;
        if (_ == undefined || _ == null) {
            $.getJSON("/products/" + $("#productAddToCart").data("handle") + ".js", function (product) {
                _ = product;
            })
        }
    }

    const LANG = window.disorder.storeLocale;
    $(".money").each(function () {
        let price = +$(this).text().replace("₪","").replace(",","");
        if (LANG.code == "en") {
            price = (price * Shopify.currency.rate).toFixed(2);
            // price = (price * window.Currency.rates.ILS).toFixed(2);
            $(this).text(`${"$"+price}`);
        }
    });
});